// toolbar.js — Tastatur für role="toolbar" (.vc-toolbar): ein Tab-Stopp, Pfeile/Pos1/Ende wandern zwischen den Knöpfen.
const ITEMS = 'button:not(:disabled), a[href], input:not([type="hidden"])';

/** Nächster Index beim Tastendruck oder null (andere Taste). */
export function toolbarStep(key, i, n) {
  if (key === 'ArrowRight' || key === 'ArrowDown') return (i + 1) % n;
  if (key === 'ArrowLeft' || key === 'ArrowUp') return (i - 1 + n) % n;
  if (key === 'Home') return 0;
  if (key === 'End') return n - 1;
  return null;
}

export function initToolbars(root = document) {
  for (const bar of root.querySelectorAll('.vc-toolbar[role="toolbar"]:not([data-ready])')) {
    bar.dataset.ready = '';
    const items = () => [...bar.querySelectorAll(ITEMS)];
    const roving = (active) => items().forEach((b) => (b.tabIndex = b === active ? 0 : -1));
    roving(items()[0]);
    bar.addEventListener('focusin', (e) => { if (items().includes(e.target)) roving(e.target); });
    bar.addEventListener('keydown', (e) => {
      const list = items(), i = list.indexOf(document.activeElement);
      if (i < 0 || e.target.matches('input')) return;
      const n = toolbarStep(e.key, i, list.length);
      if (n == null) return;
      e.preventDefault(); list[n].focus();
    });
  }
}
